import type { ZodType } from 'zod'

import required from './required'
import email from './email'

type RuleParams = {
  message?: string
}

export type Rule = (
  params?: RuleParams
) => (value: unknown) => { isValid: true } | { isValid: false; message: string }

type AgainstRule = (rule: ZodType) => Rule

const againstRule: AgainstRule = (rule: ZodType) => params => value => {
  const result = rule.safeParse(value)
  return result.success
    ? { isValid: true }
    : // eslint-disable-next-line no-underscore-dangle
      { isValid: false, message: params?.message || result.error.format()._errors[0] }
}

export default {
  required: againstRule(required),
  email: againstRule(email),
}
